import type { ReactElement } from "react"
import ButtonAtm from "@onestore/hel/dist/components/atoms/ButtonAtm"
import type Theme from "@onestore/hel/dist/typings/theme"
import _t from "@core/i18n"
import type { Size } from "@gatsby-plugin-generic-page/components/Formily/Input"
import type { HorizontalProductBox } from "@gatsby-plugin-generic-page/fragments/horizontalProductBox"
import useModalState from "~/hooks/useModalState"
import isEmpty from "~/lib/isEmpty"
import PromoModal from "./PromoModal"

type Props = {
  buttonHref: string
  hasPromotion: boolean
  isExpanded?: boolean
  isWider?: boolean
  productData?: HorizontalProductBox
  promotedHorizontalProductBox?: HorizontalProductBox[]
}

const ButtonElement = ({
  buttonHref,
  hasPromotion,
  isExpanded,
  isWider,
  productData,
  promotedHorizontalProductBox,
}: Props): ReactElement<Props> => {
  const { isOpen, open, close } = useModalState()
  const hasPromoModal = !isEmpty(promotedHorizontalProductBox)

  const handleClose = (): void => {
    close()
    window.location.href = buttonHref
  }

  const handleOpen = (): void => {
    open()
  }

  const buttonData = {
    title: _t("marketplace.chooseButton"),
    href: hasPromoModal ? undefined : buttonHref,
    onClick: hasPromoModal ? handleOpen : undefined,
    color: hasPromotion ? ("primary" as Theme.AccentColor) : "dark",
    size: "small" as Size,
    isExpanded: isExpanded,
    isWider: isWider,
  }

  return (
    <>
      <ButtonAtm {...buttonData} data-testid="table-row-button">
        {buttonData.title}
      </ButtonAtm>

      <PromoModal
        isOpen={isOpen}
        onClose={handleClose}
        buttonHref={buttonHref}
        productData={productData}
        promotedHorizontalProductBox={promotedHorizontalProductBox}
      />
    </>
  )
}

export default ButtonElement
